import LocalStorage from "@/Services/LocalStorage";

export default {
  clear() {
    LocalStorage.clear();
  },
};
